<template>
  <div
    :class="[
      status ? 'pill-active' : 'pill-not-active',
      fixedWidth ? 'pill-fixed-width' : '',
      'pill-rounded',
      'text-center',
      'px-3',
    ]"
  >
    <span :class="['pill-value', textBold && status ? 'font-weight-bold' : '']">{{ value }}</span>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    status: Boolean,
    textBold: {
      type: Boolean,
      default: false,
    },
    fixedWidth: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.pill-active,
.pill-not-active {
  padding: 9px 0;
}

.pill-fixed-width {
  width: 160px;
}

.pill-rounded {
  border-radius: 9px;
}

.pill-active {
  background-color: var(--pillActiveBgColor);
  border: 1px solid var(--pillActiveBorderColor);
  color: var(--pillActiveTextColor);
  font-weight: 500;
}

.pill-not-active {
  background-color: transparent;
  border: 1px solid var(--gray12);
  color: var(--gray11);
  font-weight: 400;
}
</style>
